import { BaseBus } from "./BaseBus";

export class PMBoardData extends BaseBus {
    constructor(data: PMBoardData = null) {
        super(data);
    }
    contractPM;
    contractPMId;
    contractNumber;
    contractId;
    jobPM;
    jobNumber;
    jobId;
    dispatchReason;
    contractDivisionId;
    divisionName;
    contractJrProjAdminId;
    jPMName;
    foremanId;
    jobForemanName;
    latestCostAdjNote;
    coordinatorId;
    coordinatorName;
    tandM;
    tAndMProfitPerc;
    lastConfirmDt;
    customerName;
    customerId;
    locationName;
    locationId;
    estimatedBeginDate;
    estimatedEndDate;
    jobTotal;
    relatedJobType;
    relatedJobTypeId;
    dateExecuted;
    locked;
    caTotal;
    contAdjTotal;
    latestSOWAdj;
    jobStatusId;
    jobStatusName;
    contractStatusId;
    contractStatusName;
    jobCost;
    bidSale;
    bidCost;
    bidHrs;
    actHrs;
    otherColumnsNeeded;
    ogJobCost;
    ogBidSale;
    ogBidCost;
    get custLocation() { return this.customerName + ' - ' + this.locationName };
    get profit() { return this.bidSale - this.jobCost };
    get percComplete() {
        if (this.bidSale != null && this.bidSale > 0) {
            return this.profit / this.bidSale
        } else { return 0 }
    };
    get completionPerc() { return (this.jobCost / (this.bidCost + this.caTotal)); };
    get completionPercFilter() {
        if (!this.completionPerc) { return 0; }
        else if (this.completionPerc < 0.75) { return 1; }
        else if (this.completionPerc >= 0.75 && this.completionPerc < 1) { return 2; }
        else if (this.completionPerc == 1) { return 3; }
        else if (this.completionPerc > 1) { return 4; }
    }
    get origEstProfit() { return this.ogBidSale - this.ogBidCost };
    get percOrigEstProfit() {
        if (this.ogBidSale != null && this.ogBidSale > 0) {
            return this.origEstProfit / this.ogBidSale
        } else { return 0 }
    };
    get budgetRemaining() { return ((this.bidCost - this.jobCost) + this.caTotal); };
    //get budgetPercComplete() { return (this.); };
    get adjCost() { return this.bidCost + this.caTotal; };
    get adjEstProfit() { return this.ogBidSale - (this.ogBidCost + this.caTotal); };
    get adjEstProfitPerc() {
        if (this.ogBidSale != null && this.ogBidSale > 0) {
            return (this.ogBidSale - (this.ogBidCost + this.caTotal)) / this.ogBidSale;
        } else { return 0 }
    };
    get contractDollars() {
        if (this.tandM && (!this.bidSale || this.bidSale == 0)) {
            return ((this.tAndMProfitPerc + 1) * this.jobCost);
        } else {
            return this.bidSale;
        }
    };
    get tandMStyling() {
        if (this.tandM && (!this.bidSale || this.bidSale == 0)) {
            return true;
        } else {
            return false;
        }
    }
    get wasConfirmed() {
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth();
        var currentDay = currentDate.getDate();
        var testDate = new Date(this.lastConfirmDt);
        var confirmYear = testDate.getFullYear();
        var confirmMonth = testDate.getMonth();
        var confirmDay = testDate.getDate();
        switch ((Math.abs(confirmMonth - currentMonth) == 0) && (Math.abs(confirmYear - currentYear) == 0)) {
            case true:
                return true;
            //has been confirmed this month
            case false:
                return false;
            //needs confirmation
        }
    }
    get minimumAdjustment() {
        //return this.budgetRemaining <= 0 ? this.budgetRemaining * -1 : null;
        return this.budgetRemaining * -1;
    }
}
